import React from "react";

const RejectionHistoryTable = ({ rejectionHistory }) => {
  // console.log(rejectionHistory);
  return (
    <div className="mt-3">
      <h5>Rejection History</h5>
      {rejectionHistory && rejectionHistory.length > 0 ? (
        <ul className="text-danger">
          {rejectionHistory.map((entry, index) => (
            <li key={index} className="fw-bold">
              {index + 1}. {entry.rejectedBy} - {entry.dateOfRejection} - {entry.reason}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-muted">No rejection history</p>
      )}
    </div>
  );
};

export default RejectionHistoryTable;
